import { callApi } from "@/api/callApi";
import { API_ENDPOINT } from "@/api/constant";
import type {
  CreateRegularizationPayload,
  // RegularizationParams,
  RegularizationListResponse,
  RegularizationItem,
  UpdateStatusPayload,
  CreateRegularizationResponse,
} from "@/interface/regularization.interface";

export const RegularizationService = {
  create: async (
    payload: CreateRegularizationPayload,
  ): Promise<CreateRegularizationResponse> => {
    return callApi<CreateRegularizationResponse>(API_ENDPOINT.regularization, {
      method: "POST",
      data: payload,
    });
  },

  getList: async (path: string): Promise<RegularizationListResponse> => {
    return callApi<RegularizationListResponse>(
      `${API_ENDPOINT.regularization}?${path}`,
      {
        method: "GET",
      },
    );
  },

  getById: async (
    id: string,
    siteId?: string,
  ): Promise<{
    data: RegularizationItem;
    status: boolean;
    message: string;
  }> => {
    const url = `${API_ENDPOINT.regularization}/${id} ${siteId ? `?siteId=${siteId}` : ""}`;
    return callApi<{
      data: RegularizationItem;
      status: boolean;
      message: string;
    }>(url, { method: "GET" });
  },

  delete: async (
    id: string,
    siteId?: string,
  ): Promise<{ status: boolean; message: string }> => {
    const url = `${API_ENDPOINT.regularization}/${id} ${siteId ? `?siteId=${siteId}` : ""}`;
    return callApi<{ status: boolean; message: string }>(url, {
      method: "DELETE",
    });
  },

  updateStatus: async (
    id: string,
    payload: UpdateStatusPayload,
  ): Promise<{ status: boolean; message: string }> => {
    const url = `${API_ENDPOINT.regularization}/${id}/status`;
    return callApi<{
      data: RegularizationItem;
      status: boolean;
      message: string;
    }>(url, {
      method: "PUT",
      data: payload,
    });
  },

  update: async (
    id: string,
    payload: CreateRegularizationPayload,
  ): Promise<CreateRegularizationResponse> => {
    const url = `${API_ENDPOINT.regularization}/${id}`;
    return callApi<CreateRegularizationResponse>(url, {
      method: "PUT",
      data: payload,
    });
  },
};
